export default "__VITE_ASSET__D6aLU5zH__"